import React, { useState } from "react"
import PropTypes from "prop-types"

import Footer from "../footer"
import MainNavigation from "../main-navigation"

import "../../../sass/style.scss"
import "./_layout.scss"

const TemplateWrapper = ({ children, countryCode, setCountryCode }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <div className="layout">
      <MainNavigation
        toggleMenu={toggleMenu}
        isMenuOpen={isMenuOpen}
        countryCode={countryCode}
        setCountryCode={setCountryCode}
      />
      <div>{children}</div>
      <Footer />
    </div>
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}

export default TemplateWrapper
